import { AfterViewInit, Component, DestroyRef, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalCampaignEmbaddedService } from 'app/campaign/services/modal-campaign-embadded.service';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-embedded-campaign-modal',
  templateUrl: './embedded-campaign-modal.component.html',
  styleUrl: './embedded-campaign-modal.component.scss',
})
export class EmbeddedCampaignModalComponent implements OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('embeddedTextArea') embeddedTextArea: ElementRef;
    
  @Input () data;

  public title = null;
  
  public themeForm: UntypedFormGroup;
  public isMultipleTicketing: boolean = false;

  public embedded: FormControl = new FormControl("");

  public type: any = null;
  public types = [{
    id: 1,
    label: 'Button'
  }, {
    id: 2,
    label: 'Form'
  }];

  public formThemeBase64: any = null;

  public donationButtonTheme: any = {
    'background-color': '#000',
    'color': '#fff'
  };

  public formTheme: any = {
    formStyles: {
      'background-color': '#ffffff',
    },
    cardStyles: {
      'background-color': '#ffffff',
      'border-color': '#e6e6e6',
    },
    optionNameStyles: {
      'color': '#000000',
    },
    selectBtnStyles: {
      'background-color': '#ffffff',
      'color': '#000000',
      'border-color': '#dfdfdf',
      
    },
    selectButtonsStyles: {
      'background-color': '#4285f4',
      'color': '#ffffff',
    },
  };

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
   private modalCampaignEmbaddedService:ModalCampaignEmbaddedService,
  ){}

  ngOnInit() {
    const json = JSON.stringify(this.formTheme);
    this.formThemeBase64 = btoa(json); // encode base64

    this.themeForm = new UntypedFormGroup({
      type: new UntypedFormControl(1),

      buttonBgColor: new UntypedFormControl("#000000"),
      buttonTextColor: new UntypedFormControl("#ffffff"),
      buttonTextColorInput: new UntypedFormControl("#ffffff"),
    
      formBgColor: new UntypedFormControl("#ffffff"),
      formHeight: new UntypedFormControl(600),
      cardBgColor: new UntypedFormControl("#ffffff"),
      optionNameColor: new UntypedFormControl("#000000"),
      selectBtnBgColor: new UntypedFormControl("#ffffff"),
      selectButtonsBgColor: new UntypedFormControl("#4285f4"),
    });

    this.type = this.themeForm.get('type')
  }

  ngAfterViewInit(): void {
    const { campaign } = this.data;
    switch(campaign.type) {
      case CAMPAIGN_TYPE.TICKETING:
        this.title = `Embed ${campaign.name} onto your website so donors can buy tickets without leaving your website`;
        this.isMultipleTicketing = campaign.campaignTypeData.multiSelect || false;
        break;
      case CAMPAIGN_TYPE.MERCHANDISE:
      case CAMPAIGN_TYPE.PARTY_SIGNUP:
        this.title = `Embed ${campaign.name} onto your website so donors can make a purchase without leaving your website`;
        this.isMultipleTicketing = true;
        break;
      default:
        this.title = `Embed ${campaign.name} onto your website so donors can make a donation without leaving your website`;
        break;
    }

    this.themeForm.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.updateEmbeddedValue();
    })

    this.updateEmbeddedValue();
  }

  updateEmbeddedValue() {
    let typeString = null;
    let theme = '';

    switch(this.type.value) {
      case 1:
        typeString = "button";
        theme = this.getDonationButtonTheme();  
        break;
      case 2:
        typeString = "form";
        theme = this.getFormTheme();  
        break;
    }
    
    const json = JSON.stringify(theme);
    const themeBase64 = btoa(json); // encode base64
    const dataTheme = `data-theme="${themeBase64}"`; 

    this.formThemeBase64 = themeBase64;
    
    const value = `
      <script type="text/javascript">!function(e,t,n) {
        if(window[t]||!window.JSON)return;window[t]={};
          let r=document.getElementsByTagName("script")[0];
          for(let s of n){
            let a=document.createElement("script");
            a.src=\`\${e}/sdk/\${s}.js\`,
            a.async=!0,
            a.addEventListener("load",async()=>{window[t].origin=e,await window[t][s].init()}),
            r.parentNode&&r.parentNode.insertBefore(a,r)
          }
          let i=document.createElement("link");
          i.href=\`\${e}/sdk/styles.css\`,
          i.rel="stylesheet",
          r.parentNode&&r.parentNode.insertBefore(i,r)
        }
        ("${window.location.origin}","PB",["campaign"]);
      </script>
      <div class="paybee-campaign" 
        data-type="${typeString}" 
        data-title="${this.getDonationButtonLabel()}" 
        data-handle="${this.data.handle}" 
        data-ppid="${this.data.campaign.intid}" 
        data-height="${this.themeForm.value.formHeight}px" 
        data-width="375px" 
        ${dataTheme}
      >
      </div>`;
  
    const oneLineCode = value.replace(/\s+/g, ' ').trim();
    this.embedded.setValue(oneLineCode)
  }

  close() {
    this.modalCampaignEmbaddedService.close();
  }

  onCopy(){
    window['toastr'].success("Embedded element was copied!");
  }

  getPaymentType(campaign) {
    return campaign.qualifiedTaxDeductible ? 0: 1;
  }

  getDonationButtonLabel() {
    const { campaign } = this.data;
    
    if (campaign.type == 8) {
        return "Share with Friends";
    }

    if (campaign.donationButtonLabel) {
        return campaign.donationButtonLabel;
    }

    if (campaign.type == 4) {
        return "Pay";
    }

    //if override is not set send based on payment type
    return campaign.qualifiedTaxDeductible ? "Donate": "Pay";
  }

  getDonationButtonTheme() {
    const bgColor = this.themeForm.value.buttonBgColor;
    const textColor = this.themeForm.value.buttonTextColor;

    this.donationButtonTheme['background-color'] = bgColor;
    this.donationButtonTheme['color'] = textColor;

    return this.donationButtonTheme;
  }

  getFormTheme() {
    const formBgColor = this.themeForm.value.formBgColor;
    const cardBgColor = this.themeForm.value.cardBgColor;
    const cardBorderColor = cardBgColor === "#ffffff" ? "#E6E6E6" : cardBgColor;
    const optionNameColor = this.themeForm.value.optionNameColor;
    const selectBtnBgColor = this.themeForm.value.selectBtnBgColor;
    const selectBtnBorderColor = selectBtnBgColor === "#ffffff" ? "#dfdfdf" : selectBtnBgColor;

    const selectButtonsBgColor = this.themeForm.value.selectButtonsBgColor;
    
    this.formTheme.formStyles['background-color'] = formBgColor;
    this.formTheme.cardStyles['background-color'] = cardBgColor;
    this.formTheme.cardStyles['border-color'] = cardBorderColor;
    this.formTheme.optionNameStyles['color'] = optionNameColor;

    this.formTheme.selectBtnStyles['background-color'] = selectBtnBgColor;
    this.formTheme.selectBtnStyles['border-color'] = selectBtnBorderColor;

    this.formTheme.selectButtonsStyles['background-color'] = selectButtonsBgColor;
    
    return this.formTheme;
  }

  onFormHeightBlur(): void {
    const formHeightControl = this.themeForm.get('formHeight');
    if (!formHeightControl.value) {
      formHeightControl.setValue(600);
    }
  }
}